import React, { useContext, useState } from 'react'
import { ApiResponseType, PERMISSION_TYPE, ROLE_TYPE, USER_PRESS_ACTION_TYPE } from '../../types';
import { createFullName, emptyFunction, getFileExtension, showToast } from '../../utils';
import FlagConfirm from '../../components/modal/FlagConfirm';
import Logo from '../../components/commonComponent/ProfileImage';
import DeleteUser from '../../components/modal/DeleteUser';
import { makeDeleteCall, makeGetCall, makePostCall } from '../../effects/requests';
import { endPoints } from '../../utils/endpoints';
import { MyContext } from '../../context';
import MessageLimitExceed from '../../pages/crewMembers/MessageLimitExceed';
import ViewPdf from '../../components/modal/ViewPdf';

interface UserBasicInfoProps {
    userData: any;
    crewDetails?: any;
    onClose: () => void;
    onAction: (type: any) => void;
    showUpdateRoleOption?: any;
    isActive?: boolean;
    isSupplier?: boolean;
    isCrew?: boolean;
    getCrewMem: any;
    sideBarArrow?: boolean;
    showDeleteOption?: boolean;
    hideMessage?: boolean;
}

const UserBasicInfo: React.FC<UserBasicInfoProps> = (props) => {

    const [selectedPdf, setSelectedPdf] = useState(null);

    const [showMoreOption, setShowMoreOption] = useState(false);
    const [confirmFlag, setConfirmFlag] = useState(false);
    const [confirmDelete, setConfirmDelete] = useState(false);
    const [showExceedMessageModal, setShowExceedMessageModal] = useState(false);

    const { userData: currentUserData, updateUserData } = useContext(MyContext)

    const onAction = (type: any) => {
        setShowMoreOption(false);
        props?.onAction?.(type)
    }

    const onRemoveAction = () => {
        makeDeleteCall(`${endPoints.COMPANY_INVITE}${props?.userData?.id}`)
            .then((res) => {
                setShowMoreOption(false);
                setConfirmDelete(!confirmDelete)
                props?.onClose()
                props?.getCrewMem()
            })
            .catch((err) => {
                showToast(err, "error")
            })
    }

    const getUserDetails = () => {
        makeGetCall(endPoints.PROFILE, null, false, true).then((res: ApiResponseType<any>) => {
            if (res?.data?.crew_member_profile?.company_department?.length > 0) {
                res?.data?.crew_member_profile?.company_department?.map((item: any) => {
                    item.label = item?.dep;
                    item.value = item?.dep;
                })
            }
            updateUserData(res);
        }).catch(emptyFunction)
    }

    const requestCv = () => {
        makePostCall(endPoints.CV_REQUEST, { cv: props?.crewDetails?.id }).then((res) => {
            getUserDetails();
        }, emptyFunction)
    }

    const messageDisabled = (props?.isCrew && !props?.hideMessage && currentUserData?.user_type === ROLE_TYPE.TYPE_SUPPLIER && currentUserData?.message_credit == 0) ? true : false

    const isCrewMem = (props?.crewDetails?.user_type === ROLE_TYPE.TYPE_CREW && props?.crewDetails?.permission_type === PERMISSION_TYPE.TYPE_CREW_MEMBER) ? true : false;

    const handlePdf = () => {
        if (!props?.crewDetails?.cv_request?.is_public && !props?.crewDetails?.cv_request?.status) {
            requestCv();
            return
        }
        if (props?.crewDetails?.cv_request?.status == 1) {
            showToast('This request has already been received.', 'error');
            return
        }
        if (props?.crewDetails?.cv_request?.status == 3) {
            showToast('This request has been rejected.', 'error');
            return
        }
        if (!props?.crewDetails?.cv_request?.cv) return
        setSelectedPdf(props?.crewDetails?.cv_request?.cv)
    }

    const handleDownload = (fileURL: any, filename: any) => {
        const pdfAcceptType = ["pdf", 'PDF'];
        const imgAcceptType = ["jpg", "jpeg", "png", "JPG", "JPEG", "PNG"];
        const common = [...imgAcceptType, ...pdfAcceptType];
        const extension = getFileExtension(fileURL);

        if (common.includes(extension)) {
            const name = createFullName(props?.crewDetails?.first_name, props?.crewDetails?.last_name);
            const aws_url = fileURL;
            const url = pdfAcceptType.includes(extension) ? endPoints.WATER_MARK : endPoints.WATER_MARK_IMAGE;
            const payload = { name, aws_url };

            makePostCall(url, payload).then((res: ApiResponseType<any>) => {
                const watermarkedURL = res?.data?.watermarked_url || fileURL;
                downloadFile(watermarkedURL, filename);
            });
        } else {
            downloadFile(fileURL, filename);
        }
    };

    const downloadFile = (fileURL: any, filename: any) => {
        // Create a virtual anchor element
        const anchor = document.createElement('a');
        anchor.href = fileURL;

        // Set the download attribute to specify the file name
        anchor.download = filename;

        // Append the anchor to the body
        document.body.appendChild(anchor);

        // Trigger a click on the anchor to initiate the download
        anchor.click();

        // Remove the anchor from the body
        document.body.removeChild(anchor);
    }

    const cvName = `${createFullName(props?.crewDetails?.first_name, props?.crewDetails?.last_name)}CV.PDF`

    return (
        <div className="popup-right-side-top">
            <div className='cross-and-dropdonw-selct d-flex justify-content-between align-items-center mb-0'>
                <img
                    src={props.sideBarArrow ? "/assets/images/arrow-donw-black.svg" : "/assets/images/dismiss-cross-black.svg"}
                    alt=""
                    className={props.sideBarArrow ? "img-cross-icon sidebarArrow" : "img-cross-icon"}
                    onClick={() => {
                        props?.onClose?.();
                        setShowMoreOption(false)
                    }}
                />
                <div className='filter-select'>
                    {!props?.isSupplier &&
                        <img
                            onClick={() => setShowMoreOption((prevState) => !prevState)}
                            src={"/assets/images/more-three-dots.svg"}
                            className="main-drop-donwe"
                            alt=""
                        />
                    }
                    <div className={`drop-down-dtost  ${showMoreOption ? "d-block" : "d-none"} `}>
                        <ul className="d-grid list-unstyled pl-0 mb-0">
                            {props?.showUpdateRoleOption &&
                                <li
                                    onClick={() => {
                                        if (props?.userData?.account_completed) {
                                            onAction?.(USER_PRESS_ACTION_TYPE.TYPE_UPDATE_ROLE)
                                        } else {
                                            showToast("Able to update the role once the profile is created completely", "info")
                                        }
                                    }}
                                >
                                    <img src={"/assets/images/update-role.svg"} alt="" />
                                    Update Role
                                </li>
                            }
                            <li
                                onClick={() => setConfirmFlag(!confirmFlag)}
                            >
                                <img src={"/assets/images/Flag-red.svg"} alt="" />
                                Flag User
                            </li>
                            {props?.showDeleteOption &&
                                <li onClick={() => setConfirmDelete(!confirmDelete)} ><img src={"/assets/images/delete-event.svg"} alt="" />Remove User</li>
                            }
                        </ul>
                    </div>
                </div>
            </div>
            <div className="profile-show-part text-center">
                {props?.userData?.logo
                    ?
                    <img className="profile-img" src={props?.userData?.logo} width="87" height="87" alt="" />
                    :
                    <Logo style={{ width: '70px', height: '70px' }} data={props?.userData?.name?.[0]} />
                }
                <h5>
                    {props.userData?.name}
                    {props.userData?.verified &&
                        <img style={{ width: '15px', height: '15px', marginLeft: '5px', marginTop: '-3px' }} src={"/assets/images/yellow_check_mark.png"} alt="" />
                    }
                </h5>
                {props.userData?.dep &&
                    <button className="perple-button mb-3">{props.userData?.dep}</button>
                }
                <ul style={props?.isSupplier ? { marginBottom: '0px' } : {}} className="list-unstyled d-flex flex-wrap align-items-center justify-content-center">
                    {props.userData?.website?.length > 0 &&
                        <li>
                            <button type='button' onClick={() => onAction?.(USER_PRESS_ACTION_TYPE.TYPE_WEBSITE)} className="btn btn-light-with-icon shadow-none">
                                <img src={"/assets/images/link-icon.svg"} alt="" />{props.userData?.linkTitle}
                            </button>
                        </li>
                    }
                    {!props?.hideMessage &&
                        <li>
                            <button
                                type='button'
                                onClick={() => {
                                    if (messageDisabled) {
                                        setShowExceedMessageModal(true)
                                        return;
                                    }
                                    onAction?.(USER_PRESS_ACTION_TYPE.TYPE_MESSAGE)
                                }}
                                className="btn btn-dark-button shadow-none"
                            >
                                <img src={"/assets/images/chat-message-icon.svg"} alt="" />
                                Message
                            </button>
                        </li>
                    }
                    {(isCrewMem && props?.crewDetails?.cv_request?.cv_exists) &&
                        <li>
                            <button
                                type='button'
                                onClick={handlePdf}
                                className="btn btn-dark-button shadow-none"
                            >
                                <img style={{ width: 20, height: 20 }} src={"/assets/images/resume_doc.png"} alt="CV" />
                                {(props?.crewDetails?.cv_request?.is_public || props?.crewDetails?.cv_request?.status == 2) ? 'View CV' : 'Request CV'}
                            </button>
                        </li>
                    }
                </ul>
                {(props?.isCrew && !props?.hideMessage && currentUserData?.user_type === ROLE_TYPE.TYPE_SUPPLIER) &&
                    <span className='message-limit'>{`You have ${currentUserData?.message_credit || 0} out of 10 messages remaining`}</span>
                }
            </div>
            <FlagConfirm
                show={confirmFlag}
                onClose={() => setConfirmFlag(!confirmFlag)}
                handleAction={() => {
                    onAction?.(USER_PRESS_ACTION_TYPE.TYPE_FLAG);
                    setConfirmFlag(!confirmFlag);
                }}
            />
            <DeleteUser
                show={confirmDelete}
                onClose={() => setConfirmDelete(!confirmDelete)}
                handleAction={onRemoveAction}
            />
            <MessageLimitExceed
                onClose={() => setShowExceedMessageModal(false)}
                show={showExceedMessageModal}
            />
            {selectedPdf &&
                <ViewPdf
                    onClose={() => { setSelectedPdf(null) }}
                    file={selectedPdf}
                    onDownload={() => handleDownload(selectedPdf, cvName)}
                />
            }
        </div>
    )
}

export default UserBasicInfo